import { render, staticRenderFns } from "./ResendConfirmationInstructions.vue?vue&type=template&id=1d3118c2&scoped=true&"
import script from "./ResendConfirmationInstructions.vue?vue&type=script&lang=js&"
export * from "./ResendConfirmationInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ResendConfirmationInstructions.vue?vue&type=style&index=0&module=true&lang=scss&"
import style1 from "./ResendConfirmationInstructions.vue?vue&type=style&index=1&id=1d3118c2&scoped=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1d3118c2",
  null
  
)

export default component.exports